import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

export class NotificationsProxy {
    async resolveTargets(input) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/back-office/notifications/resolve-targets`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(input),
        });
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async send(input) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/back-office/notifications/send`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(input),
        });
        if (!res.ok) {
            const body = await res.json().catch(() => ({}));
            throw new Error(body?.error ?? res.statusText);
        }
        return res.json();
    }

    async getHistory() {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/back-office/notifications/history`);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }
}
